import * as React from "react";
import { makeStyles } from "@material-ui/core";
import { get } from "lodash";
import moment from "moment";

import { formatCurrencyAmount } from "lib/format";
import theme from "theme";
import { Theme } from "theme";

import { DataItem } from "./OfferChart";

const useStyles = makeStyles<Theme, { color: string }>(() => ({
  container: {
    backgroundColor: theme.palette.background.default,
    border: `1px solid ${theme.custom.palette.gray.main}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1),
  },
  status: {
    color: props => props.color,
    fontSize: "1.25rem",
  },
}));

interface PayloadItem {
  name: string;
  value: number;
  payload: DataItem;
}

interface CustomTooltipProps {
  active?: boolean;
  payload?: PayloadItem[];
  currency: string;
}

const OfferChartCustomTooltip: React.FC<CustomTooltipProps> = ({
  active,
  payload,
  currency,
}) => {
  const data = get(payload, "[0].payload");
  const classes = useStyles({ color: data?.color });

  if (active) {
    return (
      <div className={classes.container}>
        {data && (
          <>
            <div className={classes.status}>{data.status}</div>
            <div>{formatCurrencyAmount(currency, data.amount)}</div>
            <div>{moment(data.date).format("MMMM Do, YYYY")}</div>
          </>
        )}
      </div>
    );
  }
  return null;
};

export default OfferChartCustomTooltip;
